// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__10n_s","col":"styles_col__2Jdj0"};